module.exports = __webpack_public_path__ + "img/ticked_line.b998432f.svg";